import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, HeldReadiness, Props } from './types';

import styles from './styles.module.scss';

const ReturnToServiceConfirm: FunctionComponent<Props> = ({
    className = '',
    droneName,
    readiness,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const questions: Record<HeldReadiness, string> = {
        grounded: t.RETURN_TO_SERVICE_QUESTION_GROUNDED({ name: droneName }),
        hold: t.RETURN_TO_SERVICE_QUESTION_HOLD({ name: droneName })
    };

    return (
        <VerticalContainer
            className={`${styles.returnToServiceConfirm} ${className}`}
            testId={testId}>
            <Wrapper className={styles.question}>{questions[readiness]}</Wrapper>

            <Wrapper className={styles.helper}>{t.RETURN_TO_SERVICE_HELPER}</Wrapper>
        </VerticalContainer>
    );
};

export default ReturnToServiceConfirm;
